import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { KpiI18Key, KpiIndex } from '@common-modules/dependencies/water-balance/kpi-type.enum';

const COMPONENT_SELECTOR = 'wlm-water-balance-custom-items';
const GRAY_COLOR = '#a6a6a6';
const BLUE_COLOR = '#4498d0';
const BLUE_INDEXS = [
  KpiIndex.SystemInputVolume,
  KpiIndex.AuthorizedConsumption,
  KpiIndex.BilledAuthorizedConsumption,
  KpiIndex.BilledUnmeteredConsumption,
  KpiIndex.BilledMeteredConsumption,
  KpiIndex.RevenueWater,
];
const GRAY_INDEXS = [
  KpiIndex.UnbilledAuthorizedConsumption,
  KpiIndex.UnbilledMeteredConsumption,
  KpiIndex.UnbilledUnmeteredConsumption,
];

export interface KpiAdapter {
  i18Key: string;
  index: number;
  className: string;
}
@Component({
    selector: COMPONENT_SELECTOR,
    templateUrl: './water-balance-custom-items.component.html',
    styleUrls: ['./water-balance-custom-items.component.scss'],
    standalone: false
})
export class WaterBalanceCustomItemsComponent implements OnInit {
  @Input() colors: { [key: number]: string } = {};
  @Output() colorChange = new EventEmitter<{ index: number; color: string }>();

  topItems = [];
  secondGroupItems = [];
  bottomItems = [];

  defaultColor = '#FF0000';

  items: KpiAdapter[] = [];

  ngOnInit() {
    this.initializeItems();
    this.assignDefaultColors(BLUE_INDEXS, BLUE_COLOR);
    this.assignDefaultColors(GRAY_INDEXS, GRAY_COLOR);

    this.topItems = this.items.slice(0, 6);
    this.secondGroupItems = this.items.slice(6, 18);
    this.bottomItems = this.items.slice(18);
  }

  assignDefaultColors(indexes: number[], color: string): void {
    indexes.forEach((index) => {
      if (!this.colors[index]) {
        this.colors[index] = color;
      }
    });
  }

  initializeItems(): void {
    this.items = [
      {
        i18Key: KpiI18Key.SystemInputVolume,
        index: KpiIndex.SystemInputVolume,
        className: 'first-input',
      },
      {
        i18Key: KpiI18Key.AuthorizedConsumption,
        index: KpiIndex.AuthorizedConsumption,
        className: 'second-input',
      },
      {
        i18Key: KpiI18Key.BilledAuthorizedConsumption,
        index: KpiIndex.BilledAuthorizedConsumption,
        className: 'third-input',
      },
      {
        i18Key: KpiI18Key.BilledMeteredConsumption,
        index: KpiIndex.BilledMeteredConsumption,
        className: 'input-group',
      },
      {
        i18Key: KpiI18Key.BilledUnmeteredConsumption,
        index: KpiIndex.BilledUnmeteredConsumption,
        className: 'input-group',
      },
      { i18Key: KpiI18Key.RevenueWater, index: KpiIndex.RevenueWater, className: 'input-group' },
      {
        i18Key: KpiI18Key.UnbilledAuthorizedConsumption,
        index: KpiIndex.UnbilledAuthorizedConsumption,
        className: 'fourd-input',
      },
      {
        i18Key: KpiI18Key.UnbilledMeteredConsumption,
        index: KpiIndex.UnbilledMeteredConsumption,
        className: 'input-group',
      },
      {
        i18Key: KpiI18Key.UnbilledUnmeteredConsumption,
        index: KpiIndex.UnbilledUnmeteredConsumption,
        className: 'input-group',
      },
      { i18Key: KpiI18Key.WaterLosses, index: KpiIndex.WaterLosses, className: 'second-input' },
      {
        i18Key: KpiI18Key.ApparentLosses,
        index: KpiIndex.ApparentLosses,
        className: 'third-input',
      },
      {
        i18Key: KpiI18Key.UnauthorizedConsumption,
        index: KpiIndex.UnauthorizedConsumption,
        className: 'input-group',
      },
      {
        i18Key: KpiI18Key.CustomerMeteringInaccuracies,
        index: KpiIndex.CustomerMeteringInaccuracies,
        className: 'input-group',
      },
      {
        i18Key: KpiI18Key.DataHandlingErrors,
        index: KpiIndex.DataHandlingErrors,
        className: 'input-group',
      },
      { i18Key: KpiI18Key.RealLosses, index: KpiIndex.RealLosses, className: 'third-input' },
      {
        i18Key: KpiI18Key.LeakageOnTransmissionMains,
        index: KpiIndex.LeakageOnTransmissionMains,
        className: 'input-group',
      },
      {
        i18Key: KpiI18Key.LeakageOnDistributionNetwork,
        index: KpiIndex.LeakageOnDistributionNetwork,
        className: 'input-group',
      },
      {
        i18Key: KpiI18Key.LeakageAndOverflowsAtUtilitysStorageTanks,
        index: KpiIndex.LeakageAndOverflowsAtUtilitysStorageTanks,
        className: 'input-group',
      },
      {
        i18Key: KpiI18Key.NonRevenueWater,
        index: KpiIndex.NonRevenueWater,
        className: 'final-input',
      },
    ];
  }

  onColorChange(index: number, newColor: string): void {
    this.colors[index] = newColor;
    this.colorChange.emit({ index, color: newColor });
  }
}
